import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollY = window.scrollY;
    const factor = 0.3;
    const rotateFactor = 0.05;  // Adjust this to control rotation speed

    // Select all columns dynamically and cast each element as HTMLElement
    const cols = document.querySelectorAll('.col');

    cols.forEach((col, index) => {
      const transformDirection = index % 2 === 0 ? -1 : 1;  // Alternate direction for each column
      const rotateDirection = index % 2 === 0 ? 1 : -1; // Alternate rotation direction

      // Cast col to HTMLElement to safely access style
      const colElement = col as HTMLElement;

      // Apply the transformations (translation and rotation)
      colElement.style.transform = `translateY(${transformDirection * scrollY * factor}px) rotate(${rotateDirection * scrollY * rotateFactor}deg)`;
    });
  }
}
